var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import ReactDOM from "react-dom";
import get from "lodash/get";
import values from "lodash/values";
import { useTranslation } from "react-i18next";
import { useEmitter, useScopedEventName } from "../helpers/customEvents";
import { ENABLED_ADMIN_FORM_TOGGLES_MAP } from "./BookingForm/booking-form.helpers";
import { ADMIN_SETTINGS_EVENT } from "./Cart/cart.helpers";
import { ReactiveForm } from "./Form";
import { componentMapper, componentTypes, validatorMapper } from "./Form/form-constants";
import styled from "styled-components";
import { usePresentationComponent } from "../AppContext";
import { useLocation } from "react-router";
import { compareAdminSettings } from './Cart/cart.helpers';
import { isSuccessRoute } from "../helpers/Routes";
import { connect } from "../store/connect";
import { getAdminBookingSettings } from "../store/stateGetter";
import { compareKeys } from "../helpers/object";
import { MAIN_WRAP } from "../classConstants";
import { getClassName } from "../helpers";
import { ThemedDiv } from "../Theme";
var adminSettingsFormFactory = function () {
    var defaultAdminSettings = {};
    var AdminSettings = function (_a) {
        var adminSettings = _a.adminSettings, _b = _a.availableSettings, availableSettings = _b === void 0 ? [] : _b, _c = _a.bookingFormRef, bookingFormRef = _c === void 0 ? null : _c, props = __rest(_a, ["adminSettings", "availableSettings", "bookingFormRef"]);
        var Renderer = usePresentationComponent("adminsettings.component") || AdminSettingsRenderer;
        var scopedAdminSettingsEvent = useScopedEventName(ADMIN_SETTINGS_EVENT);
        var adminSettingsEmitter = useEmitter(scopedAdminSettingsEvent);
        var pathName = useLocation().pathname;
        var t = useTranslation().t;
        var isSuccessScreen = isSuccessRoute();
        React.useEffect(function () {
            if (!adminSettings) {
                return;
            }
            adminSettingsEmitter(adminSettings);
        }, [JSON.stringify(adminSettings)]);
        var selectedConfiguration = availableSettings.map(function (key) { return get(adminSettings, "admin_config_toggles." + key) && t("admin_config_toggles." + key); }).filter(Boolean);
        var count = selectedConfiguration.length;
        var configurationLabel = selectedConfiguration.join(", ");
        var schema = React.useMemo(function () {
            var getDescription = function (prop) {
                var desc = t("admin_config_toggle_descriptions." + prop);
                if (!desc)
                    return null;
                return React.createElement("p", null, desc);
            };
            return {
                name: "adminsettings",
                fields: !pathName.includes("bookcart") ? [] : [{
                        name: "adminsettings",
                        component: componentTypes.BASIC,
                        context: "bookingsettings",
                        icon: "settings",
                        title: t("admin_settings.label"),
                        fields: availableSettings.map(function (prop) { return (!!get(ENABLED_ADMIN_FORM_TOGGLES_MAP, prop)
                            && !get(ENABLED_ADMIN_FORM_TOGGLES_MAP, prop, []).includes(pathName)) ? null
                            : ({
                                name: ['admin_config_toggles.', prop].filter(Boolean).join(""),
                                label: t("admin_config_toggles." + prop),
                                children: getDescription(prop),
                                component: componentTypes.CHECKBOX,
                                showCheckbox: true
                            }); }).filter(Boolean)
                    }]
            };
        }, [count, configurationLabel, pathName]);
        var onSubmit = React.useCallback(function (e) { e.preventDefault(); return; }, []);
        if (isSuccessScreen || availableSettings.length <= 0) {
            return null;
        }
        var settings = (React.createElement(Renderer, null,
            React.createElement(ReactiveForm, { name: "adminsettings", schema: schema, onSubmit: onSubmit, componentMapper: componentMapper, validatorMapper: validatorMapper, initialValues: defaultAdminSettings })));
        if (!bookingFormRef) {
            return settings;
        }
        return (ReactDOM.createPortal(React.createElement(ThemedDiv, { className: getClassName(MAIN_WRAP, "admin-setting-buttons") }, settings), bookingFormRef === null || bookingFormRef === void 0 ? void 0 : bookingFormRef.current));
    };
    var mapStateToProps = function (state) {
        return __assign(__assign({}, getAdminBookingSettings(state)), { adminSettings: get(state, "formReducer.forms.adminsettings") });
    };
    var mergeProps = function (state, dispatch, props) {
        var adminSettings = state.default ? get(state, "adminSettings") : {};
        if (!adminSettings && state.default) {
            defaultAdminSettings = { admin_config_toggles: values(state.default).reduce(function (props, key) {
                    var _a;
                    return (__assign(__assign({}, props), (_a = {}, _a[key] = true, _a)));
                }, {}) };
            adminSettings = __assign({}, defaultAdminSettings);
        }
        return __assign(__assign({ availableSettings: state.available, adminSettings: adminSettings }, dispatch), props);
    };
    var areStatePropsEqual = function (curr, prev) {
        return compareKeys(curr, prev, function (curr, prev, prop) {
            switch (prop) {
                case "adminSettings": return compareAdminSettings(curr, prev);
                default: return curr === prev;
            }
        });
    };
    return connect(mapStateToProps, null, mergeProps, { areStatePropsEqual: areStatePropsEqual })(AdminSettings);
};
var AdminSettingsRenderer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var StyledTooltip = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    vertical-align: middle;\n    display: inline-block;\n    > span {\n        vertical-align: middle;\n        display: inline-block;\n    }\n"], ["\n    vertical-align: middle;\n    display: inline-block;\n    > span {\n        vertical-align: middle;\n        display: inline-block;\n    }\n"])));
export var AdminSettings = adminSettingsFormFactory();
var templateObject_1, templateObject_2;
